import { jsx as r } from "react/jsx-runtime";
function n(o) {
  return /* @__PURE__ */ r(
    "svg",
    {
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "2",
      viewBox: "0 0 24 24",
      ...o,
      children: /* @__PURE__ */ r("path", { d: "M4 6h16M4 12h16M4 18h16" })
    }
  );
}
export {
  n as BurgerIcon
};
